module.exports = __webpack_public_path__ + "05_hige_white.3ed2249e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/05_hige_white.png
// module id = 3zzE
// module chunks = 0